module.exports = __webpack_public_path__ + "static/media/train15.dfdeae07.png";